import React, { Component } from "react";
import { tokens, profile, alert, format_date, GET, POST, PUT, DELETE, success, DatePicker, Status, loading, getStorage, toFixed, replaceTextHTML } from "../components/CustomComponent.js";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
import "../assets/css/index.css";
export default class PaymentHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      setting: {
        header_1: { status: true, title: "-โลโก้" },
        header_2: { status: true, title: "" }, // โครงการ
        header_3: { status: true, title: "" }, // ที่อยู่
        header_4: { status: true, title: "-วันที่" },
        header_5: { status: true, title: "" },
        header_6: { status: true, title: "-เรียน" },
        header_7: { status: true, title: "" }, // รายละเอียดส่วนหัว

        th_1: { status: true, title: "-รายการ" },
        th_2: { status: true, title: "-เดือน" },
        th_3: { status: true, title: "-ราคา" },

        tr_1: { status: true, title: "-ค่าน้ำประปา" },
        tr_2: { status: true, title: "-ค่ารักษาอุปกรณ์น้ำ" },
        tr_3: { status: true, title: "-ค่าจัดเก็บขยะ" },
        tr_4: { status: true, title: "-ค่าใช้จ่ายส่วนกลาง" },
        tr_5: { status: true, title: "-อื่นๆ" },
        tr_6: { status: true, title: "-ค่าค้างชำระ" },
        tr_7: { status: true, title: "-ค่าเบี้ยปรับ" },

        tr_8: { status: true, title: "-รวมเป็นเงินทั้งสิ้น" },

        footer_1: { status: true, title: "" }, // รายละเอียดส่วนท้าย
        footer_2: { status: true, title: "-ขอแสดงความนับถือ" },
        footer_3: { status: true, title: "" }, // ชื่อผู้ออกใบแจ้ง
        footer_4: { status: true, title: "" }, // ตำแหน่ง
        footer_5: { status: true, title: "" }, // หมายเหตุ
      },
    };
  }

  async componentDidMount() {
    await this.Get();
    const data = localStorage.getItem("DATA_");
    this.setState({ data: data ? JSON.parse(data) : null });
    const setting = Object.entries(this.state.setting);
    for (let item of setting) {
      if (!item[1].status) {
        try {
          let component = document.getElementsByClassName(item[0]);
          for (let co of component) {
            co.classList.add("d-none");
          }
        } catch (e) {}
      }
    }

    await replaceTextHTML();
    setTimeout(() => {
      window.print();
    }, 1000);
  }

  Get = async () => {
    loading(true);
    let result = await GET(tokens, "v1/TH/document-manage/detail/custom-document/" + getStorage("project_id"), null);
    if (result && result.status) {
      if (result.data?.data?.letter) {
        this.setState({ setting: result.data.data.letter });
      }
    }
    loading(false);
  };
  render() {
    return (
      <div className="w-100">
          <div>
            {this.state.data.map((item) => (
              <div className="mx-auto bg-white p-5 pdf-large border-bottom" style={{ width: 1116, height: 1578 }}>
                <div className="p-4">
                <div className="w-100 d-flex justify-content-between">
                  <div className="d-flex align-items-center">
                    <img src={getStorage("picture_paper") || LOGO} style={{ width: 100, height: 100, objectFit: "contain", marginRight: 6 }} alt="LOGO" className="bg-contain header_1 mb-4" />
                    <div>
                      <h2 className="fw-bold header_2 px-2 mb-0">{this.state.setting.header_2?.title || ""}</h2>
                      <div className="header_3 px-2 mb-4">{this.state.setting.header_3?.title.split("\n").map(e=>(<div>{e}</div>)) || ""}</div>
                    </div>
                  </div>
                  <div className="header_4 wpx-250 text-right mb-4">วันที่ : {format_date(new Date(), "dd mmmm yyyy")}</div>
                </div>
                <div className="header_5 mb-4">เรื่อง : เเจ้งเตือนให้ชำระค่าใช้จ่ายตามข้อบังคับ</div>
                <div className="header_6 mb-4">เรียน : {item.full_name + " ห้องเลขที่ " + item.address_number}</div>
                <div className="header_7 mb-4" style={{ textIndent: 80 }}>
                  {this.state.setting?.header_7.title}
                </div>
                <table className="table table-borderless mb-4">
                  <tr className="tr_1">
                    <td className="w-100 th_1">{this.state.setting.tr_1.status ? 1 : 0}. ค่าน้ำประปา</td>
                    <td className="w-100 text-nowrap pr-5 th_2">เดือน {format_date(item.datetime_create, "mmmm yyyy")}</td>
                    <td className="text-nowrap th_3 wpx-350">
                      <div className="d-flex justify-content-end p-0">
                        เป็นเงิน <div className="wpx-150 text-right pr-3">{toFixed(item.water_bill)}</div> บาท
                      </div>
                    </td>
                  </tr>
                  <tr className="tr_2">
                    <td className="w-100 th_1">{(this.state.setting.tr_1.status ? 1 : 0) + (this.state.setting.tr_2.status ? 1 : 0)}. ค่ารักษาอุปกรณ์การใช้น้ำ</td>
                    <td className="w-100 text-nowrap pr-5 th_2">เดือน {format_date(item.datetime_create, "mmmm yyyy")}</td>
                    <td className="text-nowrap th_3 wpx-350">
                      <div className="d-flex justify-content-end p-0">
                        เป็นเงิน <div className="wpx-150 text-right pr-3">{toFixed(item.equipment_maintenance_fee)}</div> บาท
                      </div>
                    </td>
                  </tr>
                  <tr className="tr_3">
                    <td className="w-100 th_1">{(this.state.setting.tr_1.status ? 1 : 0) + (this.state.setting.tr_2.status ? 1 : 0) + (this.state.setting.tr_3.status ? 1 : 0)}. ค่าบริการจัดเก็บขยะ</td>
                    <td className="w-100 text-nowrap pr-5 th_2">เดือน {format_date(item.datetime_create, "mmmm yyyy")}</td>
                    <td className="text-nowrap th_3 wpx-350">
                      <div className="d-flex justify-content-end p-0">
                        เป็นเงิน <div className="wpx-150 text-right pr-3">{toFixed(item.waste_cost)}</div> บาท
                      </div>
                    </td>
                  </tr>
                  <tr className="tr_4">
                    <td className="w-100 th_1">{(this.state.setting.tr_1.status ? 1 : 0) + (this.state.setting.tr_2.status ? 1 : 0) + (this.state.setting.tr_3.status ? 1 : 0) + (this.state.setting.tr_4.status ? 1 : 0)}. ค่าใช้จ่ายส่วนกลาง</td>
                    <td className="w-100 text-nowrap pr-5 th_2">เดือน {format_date(new Date(item.datetime_create).setMonth(new Date(item.datetime_create).getMonth() + 1), "mmmm yyyy")}</td>
                    <td className="text-nowrap th_3 wpx-350">
                      <div className="d-flex justify-content-end p-0">
                        เป็นเงิน <div className="wpx-150 text-right pr-3">{toFixed(item.common_expenses)}</div> บาท
                      </div>
                    </td>
                  </tr>
                  <tr className="tr_5">
                    <td className="w-100 th_1">{(this.state.setting.tr_1.status ? 1 : 0) + (this.state.setting.tr_2.status ? 1 : 0) + (this.state.setting.tr_3.status ? 1 : 0) + (this.state.setting.tr_4.status ? 1 : 0) + (this.state.setting.tr_5.status ? 1 : 0)}. อื่นๆ</td>
                    <td className="w-100 text-nowrap pr-5 th_2">เดือน {format_date(item.datetime_create, "mmmm yyyy")}</td>
                    <td className="text-nowrap th_3 wpx-350">
                      <div className="d-flex justify-content-end p-0">
                        เป็นเงิน <div className="wpx-150 text-right pr-3">{toFixed(item.other_income + item.fire_cost + item.cable_cost + (item.meter_connect_cost || 0) + ((item.add_debt || 0) - (item.reduce_debt || 0)))}</div> บาท
                      </div>
                    </td>
                  </tr>
                  <tr className="tr_6">
                    <td className="w-100 th_1">
                      {(this.state.setting.tr_1.status ? 1 : 0) + (this.state.setting.tr_2.status ? 1 : 0) + (this.state.setting.tr_3.status ? 1 : 0) + (this.state.setting.tr_4.status ? 1 : 0) + (this.state.setting.tr_5.status ? 1 : 0) + (this.state.setting.tr_6.status ? 1 : 0)}. ค่าค้างชำระ {item.count_installment ? item.count_installment - 1 : 0} งวด
                    </td>
                    <td className="w-100 text-nowrap pr-5 th_2"></td>
                    <td className="text-nowrap th_3 wpx-350">
                      <div className="d-flex justify-content-end p-0"> 
                        เป็นเงิน <div className="wpx-150 text-right pr-3">{toFixed(item.overdue_amount)}</div> บาท
                      </div>
                    </td>
                  </tr>
                  <tr className="tr_7">
                    <td className="w-100 th_1">{(this.state.setting.tr_1.status ? 1 : 0) + (this.state.setting.tr_2.status ? 1 : 0) + (this.state.setting.tr_3.status ? 1 : 0) + (this.state.setting.tr_4.status ? 1 : 0) + (this.state.setting.tr_5.status ? 1 : 0) + (this.state.setting.tr_6.status ? 1 : 0) + (this.state.setting.tr_7.status ? 1 : 0)}. ค่าเบี้ยปรับ</td>
                    <td className="w-100 text-nowrap pr-5 th_2"></td>
                    <td className="text-nowrap th_3 wpx-350">
                      <div className="d-flex justify-content-end p-0">
                        เป็นเงิน <div className="wpx-150 text-right pr-3">{toFixed(item.total_cost_late)}</div> บาท
                      </div>
                    </td>
                  </tr>
                  <tr className="tr_8">
                    <td className="w-100 th_1"></td>
                    <td className="w-100 text-nowrap pr-5 th_2"></td>
                    <td className="text-nowrap th_3 wpx-350">
                      <div className="d-flex justify-content-end p-0">
                        รวมเป็นเงินทั้งสิ้น <div className="wpx-150 text-right pr-3">{toFixed(item.total_amount + item.overdue_amount)}</div> บาท
                      </div>
                    </td>
                  </tr>
                </table>
                <div className="footer_1 mb-4" style={{ textIndent: 80 }}>
                  {this.state.setting?.footer_1.title}
                </div>
                <div className="w-50 ml-auto text-center">
                  <div className="text-center w-100 footer_2 mt-5">ขอแสดงความนับถือ</div>
                  <div className="text-center w-100 footer_3">({this.state.setting?.footer_3.title})</div>
                  <div className="text-center w-100 footer_4 mb-5">{this.state.setting?.footer_4.title}</div>
                </div>
                <div className="footer_5 mb-4">หมายเหตุ : {this.state.setting.footer_5?.title.split("\n").map(e=>(<div>{e}</div>)) || ""}</div>
              </div>
              </div>
            ))}
          </div>
      </div>
    );
  }
}
